import { FormOutlined } from '@ant-design/icons';
import { Badge, Button, Divider, message, Space, Table, Tooltip, Modal } from "antd";

import moment from "moment";
import React, { useRef, useState } from "react";

import conditional from "../../tools/conditional";
import { apiCall } from "../../utils/Api";
import { bmDate, ucfirst } from "../../utils/Utils";
import TitleRenderers from "./TitleRenderers";
import Html from '../../utils/Html';
import ShowMore from '../ShowMore';

export default function TitleEditField(props) {
    const { editing, field, isbn, annotation = false, edit = {}, tooltip = "", displayOnly = false } = props;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({ rows: [], type: "", can_use_pick: false });
    const [value, setValue] = useState("");
    const [visible, setVisible] = useState(false);
    const [row, setRow] = useState(null);
    const [show, setShow] = useState(null)
    const [valid, setValid] = useState(true);
    const [type, setType] = useState("title_heap");
    const [title, setTitle] = useState("Edit");



    const name = (props.name) ? props.name : ucfirst(field.replace("_", " "));

    const close = () => {
        setVisible(false);
        setValid(true);
        setRow(null);
    }

    const addRowKeys = (_arr) => {
        return (_arr.map((item) => {
            item["key"] = item.row_id;
            return item;
        }))
    }


    const ShowField = (props) => {
        const { data = "", is_new = false } = props;
        if (!annotation) {
            return (<></>)
        }

        const openModal = () => {
            Modal.info({
                width: 900,
                maskClosable: true,
                okText: "Close",
                icon: null,
                content: <><Html html={data} /></>
            })
        }


        return (<Button disabled={is_new} onClick={() => openModal()} size="small"><small>Show</small></Button>)

    }

    const getEdit = (_visible, _title = "Edit") => {
        if (visible) {
            close();
            return;
        }
        setTitle(_title);
        setValue("");
        setLoading(true);
        let _obj = {}
        _obj.isbn = isbn;
        _obj.field = field;
        // eslint-disable-next-line default-case
        switch (_obj.field) {
            case "main_description":
                _obj.field = "annotation_1"
                break;
            case "short_description":
                _obj.field = "annotation_2"
                break;
            case "long_description":
                _obj.field = "annotation_3"
                break;
            case "review_quote":
                _obj.field = "annotation_8"
                break;
            case "reader_description":
                _obj.field = "annotation_12"
                break;
            case "biographical_note":
                _obj.field = "annotation_13"
                break;
        }
        // overwrite field with id if it's an annotation
        if (annotation) {
            _obj.field = "annotation_" + annotation.id.toString();
        }
        if (_visible) {
            apiCall("title/getSpecificEdit", _obj, (_status, _result) => {
                if (_status) {
                    addRowKeys(_result.rows)
                    setType(_result.type);


                    let _n = {
                        "title_weight": 0,
                        "data": "",
                        "source_display": "",
                        "source_san": "",
                        "source_id": "",
                        "date_created": 0,
                        "date_changed": 0,
                        "row_id": 0,
                        "isbn": isbn,
                        "eisbn": "",
                        "banned_bisacs": null,
                        "is_editable": true,
                        "sender": null,
                        "new": true,
                    }

                    let _f = (_result.rows.find(item => item.is_editable));
                    if (!_f) {
                        _result.rows.unshift(_n);
                    }

                    setData(_result);
                    setVisible(true);
                    setLoading(false);
                } else {
                    message.error("Not available.")
                }
            })
        }
    }

    const saveEdit = () => {
        if (!value) {
            setValid(false);
            return;
        }
        let obj = {}
        obj.value = value;
        obj.isbn = isbn;
        if (annotation) {
            obj.note_id = annotation.id;
            obj.field = field;
            if (row?.row_id) {
                obj.row_id = row?.row_id;
            }
            apiCall("title/saveAnnotation", obj, (_status, _result) => {
                if (_status) {
                    message.success("Update requested");
                } else {
                    message.error(_result.error);
                }
                close()
            })
        } else {
            obj.type = type;
            obj.field = field;
            if (row?.row_id) {
                obj.row = row.row_id;
            }
            apiCall("title/save", obj, (_status, _result) => {
                if (_status) {
                    message.success("Update requested");
                } else {
                    message.error(_result.error)
                }
                close()
            })
        }
    }

    const deleteEdit = (_row = row) => {




        let obj = {}
        obj.type = type;
        obj.isbn = isbn;
        if (annotation) {
            if (_row?.row_id) {
                obj.row_id = _row.row_id;
            }
            obj.note_id = annotation.id;

            apiCall("title/deleteAnnotation", obj, (_status, _result) => {
                if (_status) {
                    message.success("Record deleted");
                } else {
                    message.error(_result.error)
                }
                close()
            })
        } else {
            obj.field = field;
            if (_row?.row_id) {
                obj.row = _row.row_id;
            }
            apiCall("title/delete", obj, (_status, _result) => {
                if (_status) {
                    message.success("Record deleted");
                } else {
                    message.error(_result.error)
                }
                close()
            })
        }
    }

    const columns = [
        {
            title: <small></small>, width: "20px", style: { "padding": "0px" }, dataIndex: 'fs', key: 'fs', render: (e, f) => {
                return (<Badge style={{ "paddingLeft": "12px" }} color={(f.is_editable) ? "#87ceeb" : "#d3d3d3"} />)
            }
        },
        {
            title: <small>Value</small>, dataIndex: 'data', key: 'data', render: (e, f) => {
                return (e) ?
                    <ShowMore text={e} />
                    : "";
            }
        },
        {
            title: <small>Source</small>, dataIndex: 'source_display', key: 'source_display', render: (e, f) => {
                return (e) ? <span>{e} [{f.source_san}]</span> : "";
            }
        },
        // { title: <small>CID</small>, dataIndex: 'source_id', key: 'source_id' },
        {
            title: <small>Created</small>, width: "75px", dataIndex: 'date_created', key: 'date_created', render: (e) => {
                return (e) ? <span>{bmDate(e * 1000)}</span> : "";
            }
        },
        {
            title: <small>Modified</small>, width: "75px", dataIndex: 'date_changed', key: 'date_changed', render: (e) => {
                return (e) ? <span>{bmDate(e * 1000)}</span> : "";
            }
        },
        { title: <small></small>, width: "0x", style: { "padding": "0px" }, dataIndex: 'bs', key: 'bs' },
        {
            title: <small>Priority</small>, width: "60px", dataIndex: 'title_weight', key: 'title_weight'
        },
        {
            title: <small>Actions</small>, width: "50px", dataIndex: 'title_weight', key: 'title_weight', render: (e, f) => {
                return (
                    <Space>
                        <ShowField data={f.data} />
                        <Button style={{ "width": (f?.new) ? "50px" : "50px" }} type={(f.is_editable) ? 'primary' : "default"} onClick={() => {

                            setRow((row === f.row_id) ? null : f);
                            setValue(f?.data);
                        }} size='small'><small>{(row === f.row_id) ? (f.is_editable) ? "Close" : "Hide" : (f.is_editable) ? (f?.new) ? "New" : "Edit" : "Copy"}</small></Button>
                        {/* {(!f?.new && <Button onClick={() => deleteEdit(f)} disabled={!f.is_editable} danger type='primary' size='small'><small>Delete</small></Button>)} */}
                    </Space>
                )

            }
        },

    ]

    // "title_weight": 1001,
    // "data": "I Love Corgis! : this is the subtitle by bookmanager",
    // "source_display": "",
    // "date_created": 1628183900,
    // "date_changed": 1628183900,
    // "row_id": 76076143,
    // "isbn": "ATEST00000000",
    // "eisbn": "Ryan_Y-Z0UVpa4PqhAdL4w",
    // "banned_bisacs": null,
    // "is_editable": false

    const onRowClick = (_record) => {


        setRow((row === _record.row_id) ? null : _record);
        setValue(_record?.data);

    }



    const drawEditForm = () => {



        const _title = (field !== "title") ? title : <>Edit title: <em><small>{edit[field]}</small></em></>;
        return (
            <Modal destroyOnClose title={_title} width={1000} style={{ "marginTop": "50px" }} onCancel={() => setVisible(false)} footer={null} visible={visible}>
                <div style={{ "margin": "-12px -16px" }}>

                    <conditional.true value={data.rows.length > 0}>
                        <Table
                            size="small"
                            rowClassName={(record) => { return (record.row_id === row?.row_id) ? "ant-table-row-selected" : "" }}
                            loading={loading}
                            columns={columns}
                            dataSource={data.rows}
                            pagination={false}
                            scroll={{ y: 300, x: "auto" }}
                            onRow={(record, rowIndex) => {
                                return {
                                    onClick: event => { onRowClick(record) },
                                };
                            }}
                        />
                    </conditional.true>
                    <div className="shim"></div>
                    {row &&
                        <div className="shadow-large" style={{ "padding": "10px 20px", "border": "2px solid #88888866", "borderRadius": "5px" }}>
                            <TitleRenderers isbn={isbn} can_use_pick={data.can_use_pick} valid={valid} edit={edit} value={value} setValue={setValue} field={field} />

                            <div className='float-flex'>
                                <div></div>
                                <div>
                                    <Space>
                                        <Button size="small" onClick={() => setRow(null)} ><small>Close</small></Button>
                                        {/* <conditional.true value={(!row?.new)}>
                                            <Button disabled={!row?.is_editable} danger size="small" onClick={() => deleteEdit(row)} ><small>Delete</small></Button>
                                        </conditional.true> */}
                                        <Button size="small" onClick={() => saveEdit()} type="primary"><small>{(row?.is_editable && !row?.new) ? "Update" : "Save New"}</small></Button>
                                    </Space>
                                </div>
                            </div>

                            <br clear="all" />
                            <div className="shim"></div>
                        </div>
                    }

                </div>
            </Modal>
        )
    }

    if (!editing) {
        return props.children;
    }

    if (displayOnly) {
        return (<><span><em style={{ "opacity": "0.6" }}>{field} displays as: </em></span>{props.children}</>)
    }

    return (
        <>
            {props.children}
            {drawEditForm()}
            <conditional.true value={(!props.children)}>
                <conditional.true value={(edit[field])}>
                    {edit[field]}
                </conditional.true>
            </conditional.true>
            <Tooltip title={tooltip}><a onClick={() => getEdit(true, "Edit " + name)} > {(annotation) ? <small><nobr>{"Edit " + name + " "}</nobr></small> : <small style={{ "fontSize": "12px" }}>{((edit[field])) ? <><nobr>Edit {field} <FormOutlined style={{ "fontSize": "11px", "lineHeight": "0px" }} /></nobr></> : <>[{field}]</>}</small>}<small></small></a></Tooltip>
        </>);
}